import {
  BatchId,
  BatchType,
  BatchLocation,
  BatchSurface,
  BatchEconomicInfo,
  BatchWindow,
  BatchCertifications,
  BatchPurpose,
  BatchAlreadyWithOfferFlag
} from '@/Domain/Batch'
import { Species } from '@/Domain/Batch/Species'
import { BatchSituation } from '@/Domain/Batch/BatchSituation'
import { BatchIntervention } from '@/Domain/Batch/BatchIntervention'

export class Batch {
  private _batchId: BatchId
  private _batchType: BatchType
  private _batchCertifications: BatchCertifications
  private _batchLocation: BatchLocation
  private _batchIntervention: BatchIntervention
  private _batchSurface: BatchSurface
  private _batchEconomicInfo: BatchEconomicInfo
  private _batchWindow: BatchWindow
  private _batchVolumeUnit: string
  private _batchAlreadyWithOffer: BatchAlreadyWithOfferFlag
  private _species: Species[]

  constructor (
    batchId: BatchId,
    batchType: BatchType,
    batchCertifications: BatchCertifications,
    batchLocation: BatchLocation,
    batchIntervention: BatchIntervention,
    batchSurface: BatchSurface,
    batchEconomicInfo: BatchEconomicInfo,
    batchWindow: BatchWindow,
    batchVolumeUnit: string,
    batchAlreadyWithOffer: BatchAlreadyWithOfferFlag,
    species: Species[]

  ) {
    if (species.length === 0) {
      throw new RangeError('Species of a Batch cannot be empty')
    }
    this._batchId = batchId
    this._batchType = batchType
    this._batchCertifications = batchCertifications
    this._batchLocation = batchLocation
    this._batchIntervention = batchIntervention
    this._batchSurface = batchSurface
    this._batchEconomicInfo = batchEconomicInfo
    this._batchWindow = batchWindow
    this._batchVolumeUnit = batchVolumeUnit
    this._batchAlreadyWithOffer = batchAlreadyWithOffer
    this._species = species
  }

  batchId (): string {
    return this._batchId.batchId()
  }

  recordId (): string {
    return this._batchId.recordId()
  }

  batchType (): BatchType {
    return this._batchType
  }

  mount (): string {
    return this._batchLocation.mount()
  }

  owner (): string {
    return this._batchLocation.owner()
  }

  county (): string {
    return this._batchLocation.county()
  }

  surface (): string {
    return this._batchSurface.toString()
  }

  appraisal (): string {
    return this._batchEconomicInfo.appraisal()
  }

  taxes (): string {
    return this._batchEconomicInfo.taxes()
  }

  temporaryDeposit (): string {
    return this._batchEconomicInfo.temporaryDeposit()
  }

  window (): number {
    return this._batchWindow.window()
  }

  uneCertification (): boolean {
    return this._batchCertifications.uneCertification()
  }

  fscCertification (): boolean {
    return this._batchCertifications.fscCertification()
  }

  volumeUnit (): string {
    return this._batchVolumeUnit
  }

  alreadyWithOfferFlag (): boolean {
    return this._batchAlreadyWithOffer.alreadyWithOffer()
  }

  species (): Species[] {
    return this._species
  }

  situation (): BatchSituation {
    return this._batchIntervention.situation()
  }

  purpose (): BatchPurpose {
    return this._batchIntervention.purpose()
  }
}
